module.exports = __webpack_public_path__ + "img/product7.c718c3ae.png";